var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyMassagesActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2 51.1914C22.96 51.1914 0 74.1514 0 102.391V255.991C0 284.231 22.96 307.191 51.2 307.191H76.8V345.591C76.8 350.471 79.52 354.871 83.84 357.031C88.16 359.191 93.36 358.711 97.28 355.831L162.16 307.191H281.6C309.84 307.191 332.8 284.231 332.8 255.991V102.391C332.8 74.1514 309.84 51.1914 281.6 51.1914H51.2ZM281.6 332.791H204.8V358.391C204.8 386.631 227.76 409.591 256 409.591H349.84L414.72 458.231C418.56 461.111 423.76 461.591 428.16 459.431C432.56 457.271 435.2 452.871 435.2 447.991V409.591H460.8C489.04 409.591 512 386.631 512 358.391V204.791C512 176.551 489.04 153.591 460.8 153.591H358.4V255.991C358.4 298.391 324 332.791 281.6 332.791Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMassagesActiveIcon);
export default __webpack_public_path__ + "static/media/my-massages-active-icon.7084a8e0e67ac0161653c3941916e8cf.svg";
export { ForwardRef as ReactComponent };